import React from 'react'
import mercadoLibre from '../../images/aliado1.webp'
import falabella from '../../images/FalabellaLogo.png'
import enviame from '../../images/aliado2.webp'
import shippit from '../../images/aliado3.webp'
import logisticplus from '../../images/logisticPlus.webp'
import pheroLogo from '../../images/pheroLogo.webp'
import { Link } from 'gatsby'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function OurPartners() {

    const settings = {
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 2000,
    };

  return (
    <div className="Content__ourPartners">
        <div className="container">
            <div className="Content__ourPartners--container">
                <div className="Content__ourPartners--left">
                    <div className="Content__ourPartners--title">
                        <h2>Nuestros <span>partners</span></h2>
                    </div>
                    <div className="Content__ourPartners--subtitle">
                        <span>¡Haz tus envíos con nosotros!</span>
                    </div>
                </div>
                <Slider {...settings} className="Content__ourPartners--partners-container">
                    {/* <div className="Content__ourPartners--partner">
                        <img src={pheroLogo} alt="phero-logo" width="115" height="36" />
                    </div> */}
                    <div className="Content__ourPartners--partner">
                        <img src={mercadoLibre} alt="mercadolibre-logo" width="180" height="53" />
                    </div>
                    <div className="Content__ourPartners--partner">
                        <img src={falabella} alt="falabella-logo" width="180" height="53" />
                    </div>
                    <div className="Content__ourPartners--partner">
                        <img src={enviame} alt="enviame-logo" width="180" height="53" />
                    </div>
                    <div className="Content__ourPartners--partner">
                        <img src={shippit} alt="shipit-logo" width="180" height="53" />
                    </div>
                    <div className="Content__ourPartners--partner">
                        <img style={{maxHeight: '70px'}} src={logisticplus} alt="logisticplus-logo" width="113" height="69" />
                    </div>
                </Slider>
                <div className="Content__ourPartners--right">
                    <div className="Content__ourPartners--button">
                        <Link to={'/contacto'}>
                            <button>Hablemos</button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export { OurPartners }